export default "__VITE_ASSET__D86A91TX__"